import React, { memo } from 'react'

import HowToEarnRewards from '../../../components/popups/reward/HowToEarnRewards'

const HowToEarnPopupWrapper = (props) => {
  return <HowToEarnRewards {...props} />
}

export default memo(HowToEarnPopupWrapper)
